import StyledBox from './StyledBox';

export type { StyledBoxProps } from './StyledBox';

export { StyledBox };
export default StyledBox;
